'use strict';

bbw.directive.BbwDropdownController = ngtk.controller.Base.extend({

    $inject: ['$scope', '$element', '$timeout'],

    _init: function() {
        this.$scope.isOpened = false;
        this.$scope.open = this.open.bind(this);
        this.$scope.close = this.close.bind(this);
        this.$scope.toggle = this.toggle.bind(this);
        this.isDisabled = false;
    },

    open: function() {
        this.$scope.dropdown.isOpened = !this.isDisabled;
        bbw.browser.msie && this.$timeout(angular.noop);
    },

    close: function() {
        this.$scope.dropdown.isOpened = false;
        bbw.browser.msie && this.$timeout(angular.noop);
    },

    toggle: function() {
        this.$scope.dropdown.isOpened = this.isDisabled ? false : !this.$scope.dropdown.isOpened;
        bbw.browser.msie && this.$timeout(angular.noop);
    }

});

bbw.directive.bbwDropdown = ['bbw.LayoutTypeSvc', function(layoutType) {

    return {
        scope: true,
        controller: bbw.directive.BbwDropdownController,
        controllerAs: 'dropdown',
        link: function(scope, element, attrs, ctrl) {
            var closeTimeout;
            var openedClass = '-opened';
            if (attrs.bbwDropdownOpenedClass) {
                openedClass = scope.$eval(attrs.bbwDropdownOpenedClass);
            }

            function updateDisabled() {
                ctrl.isDisabled = !!scope.$eval(attrs.disabled);
            }

            attrs.$observe('disabled', updateDisabled);

            var isTouch = false;
            if (attrs.clickMode || layoutType.hasTouch()) {
                isTouch = true;
            }

            function cancelCloseTimeout() {
                if (angular.isDefined(closeTimeout)) {
                    clearTimeout(closeTimeout);
                    closeTimeout = undefined;
                }
            }

            if (isTouch) {
                element[0].setAttribute('tabindex', 9999);
                element.on('click', function() {
                    scope.$safeApply(function() {
                        ctrl.toggle();
                    });
                });
                element.on('blur', function() {
                    scope.$safeApply(function() {
                        ctrl.close();
                    });
                });
            } else {
                element.on('mouseenter', function() {
                    cancelCloseTimeout();
                    scope.$safeApply(function() {
                        ctrl.open();
                    });
                });

                element.on('mouseleave', function() {
                    if (closeTimeout) {
                        return;
                    }
                    closeTimeout = setTimeout(
                        function() {
                            scope.$safeApply(function() {
                                ctrl.close();
                            });
                        }, 300
                    );
                });
            }

            scope.$watch('dropdown.isOpened', function(value) {
                if (value) {
                    element.addClass(openedClass);
                } else {
                    element.removeClass(openedClass);
                }
            });

            scope.$on('$destroy', cancelCloseTimeout);
        }
    }

}];

bbw.directive.bbwDropdownList = function() {

    return {
        require: '^bbwDropdown',
        link: function(scope, element) {
            var isFirst = true;
            var timeout;
            scope.$watch('dropdown.isOpened', function(value, oldValue) {
                if (bbw.browser.msie && timeout) {
                    element.css('display', 'none');
                    clearTimeout(timeout);
                    timeout = undefined;
                }
                if (value) {
                    element.css('display', 'block');
                } else {
                    if (bbw.browser.msie) {
                        if (isFirst) {
                            element.css('display', 'none');
                        } else {
                            timeout = setTimeout(function() {
                                element.css('display', 'none');
                                timeout = undefined;
                            }, 150);
                        }
                    } else {
                        element.css('display', 'none');
                    }
                    isFirst = false;
                }
            });
        }
    }

};
